import styled from "styled-components";

export const ShopperBrowserActionsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TransparentButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;

  display: flex;
  margin-right: 10px;
`;

export const ShopperBrowserSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  padding: 24px 0;
`;

export const ShopperBrowserForm = styled.form`
  display: flex;
  flex-direction: column;
`;

export const GroupedInputsContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 8px;
`;
